<template>
  <div class="home" id="home">
    <div id="left1">
      <div id="drag">
        <div class="Yuan" @click="testShowBtn">
          <span></span>
          <span></span>
        </div>
        <div class="Yuan-title">
          <div class="YuanTitleDrag"></div>
          <div class="zTreeDiv">
            <ul id="WorkPlaneTree" class="ztree"></ul>
          </div>
        </div>
      </div>

      <div id="MyViewerDiv"></div>

      <canvas id="snapshot" hidden></canvas>
      <img id="test" />
      <div id="div_viewpoint" class="m-right-sidebar">
        <h2 class="sdbcName">视点保存</h2>
        <div
          class="btnClose close_bt_p"
          onclick="bimViewPointNew.hiddenViewPoint();"
        >
          ×
        </div>
        <div class="navBox">
          <div id="search_viewpoint" class="search">
            <b class="imgsearch"></b>
            <button
              id="vp-imgsearch"
              class="btnSearch"
              onclick="bimViewPointNew.filterNodes()"
            >
              <img
                width="20px"
                class="pos-re-left4"
                src="../../assets/img/搜索 (2).png"
              />
            </button>
            <input
              type="text"
              id="vp-searchtxt"
              value="请输入搜索内容..."
              onfocus="if(value=='请输入搜索内容...')  {value=''}"
              onblur="if (value=='') {value='请输入搜索内容...'}"
              onkeypress="bimViewPointNew.viewpoint_keydown(event)"
              name="name"
            />
            <b class="clo1" id="vp-close" onclick="bimViewPointNew.closeShow()"
              >×</b
            >
          </div>
        </div>
        <div class="body_viewpoint">
          <div
            id="viewpointUser"
            style="width: 100%; max-height: 10%; overflow: auto"
          ></div>
          <ul id="treeDemo_viewpoint" class="treeDemo_viewpoint ztree"></ul>
        </div>
        <div class="w-h-bg-cor">
          <el-button
            type="primary"
            id="vp-btn-mark"
            data-placement="bottom"
            title="涂鸦"
            size="small"
            onclick="bimViewPointNew.showMarkTool()"
            >涂鸦</el-button
          >

          <el-button
            type="primary"
            id="vp-btn-save"
            data-placement="bottom"
            size="small"
            title="保存"
            onclick="bimViewPointNew.onSaveLayer()"
            >保存</el-button
          >

          <el-button
            type="primary"
            id="vp-btn-save"
            data-placement="bottom"
            size="small"
            title="分享管理"
            @click="shareManageInit"
            >分享管理</el-button
          >
        </div>
        <div id="rMenu_viewpoint" class="rMenu pos-fixed">
          <ul id="rShowMenu_viewpoint">
            <li
              id="vp_m_add"
              class="dis-lis-item"
              onclick="bimViewPointNew.addTreeNode()"
            >
              新建视点目录
            </li>
            <li
              id="vp_m_del"
              class="dis-lis-item"
              onclick="bimViewPointNew.removeTreeNode()"
            >
              删除
            </li>
            <li
              id="vp_m_ren"
              class="dis-lis-item"
              onclick="bimViewPointNew.renameTreeNode()"
            >
              重命名
            </li>
            <li
              id="vp_m_visible"
              class="dis-lis-item"
              onclick="bimViewPointNew.setVisible()"
            >
              可见
            </li>
            <li
              id="vp_m_share"
              onclick="bimViewPointNew.shareTreeNode()"
              class="dis-lis-item"
            >
              分享视点
            </li>
          </ul>
        </div>
      </div>
      <!-- <div id="box_gray" class="gray"></div> -->
      <!-- @*过滤器*@ -->
      <div class="filter_box" id="gg">
        <div class="box_title" id="box_title">过滤器</div>
        <div class="btnClose" onclick="bimOriginFilter.hideDoc()">×</div>
        <div class="box_content">
          <div class="tab_title">
            <ul id="tabs" class="clearfix">
              <li class="current" onclick="boxselect(this)">
                <a href="#" title="过滤器">过滤器</a>
              </li>
              <li onclick="boxselect(this)">
                <a href="#" title="选择集">选择集</a>
              </li>
            </ul>
          </div>
          <div id="menu_content_box">
            <div id="tab1" class="menu_table dis-bok">
              <div class="farther" id="list">
                <div class="body_origin_filter">
                  <ul id="treeDemo_origin_filter" class="ztree scroll_bar"></ul>
                </div>
                <div id="rMenu_origin_filter" class="rMenu">
                  <ul id="rShowMenu_origin_filter">
                    <li
                      class="dis-none"
                      id="origin_f_add"
                      onclick="bimOriginFilter.xx()"
                    >
                      增加
                    </li>
                    <li
                      id="origin_f_del"
                      onclick="bimOriginFilter.yy()"
                      class="dis-none"
                    >
                      删除
                    </li>
                    <li
                      id="origin_f_ren"
                      onclick="bimOriginFilter.zz()"
                      class="dis-none"
                    >
                      重命名
                    </li>
                  </ul>
                </div>
              </div>
              <div class="footr_box">
                <div class="box_btn_op">
                  <div class="clearfix">
                    <el-button
                      class="fr ml_20 mar-top3"
                      type="primary"
                      onclick="bimOriginFilter.attribute_save()"
                      size="small"
                      >保存</el-button
                    >
                    <el-button
                      class="fr ml_20 mar-top3"
                      style="margin-right: 10px"
                      type="primary"
                      @click="hightFilter"
                      size="small"
                      >高级筛选</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
            <div id="tab2" class="menu_table dis-none">
              <div class="farther" id="list">
                <div class="body_originOther_filter">
                  <div
                    id="modelselectUser"
                    style="width: 100%; max-height: 10%; overflow: auto"
                  ></div>
                  <ul
                    id="treeDemo_originOther_filter"
                    class="ztree scroll_bar"
                  ></ul>
                </div>
                <div id="rMenu_originOther_filter" class="rMenu pos-fixed">
                  <ul id="rShowMenu_originOther_filter">
                    <li
                      id="originOther_f_addPlanDir"
                      onclick="bimOriginFilter.addPlanDir()"
                    >
                      新建目录
                    </li>
                    <li
                      id="originOther_f_delPlan"
                      onclick="bimOriginFilter.removePlan()"
                    >
                      删除
                    </li>
                    <li
                      id="originOther_f_renPlan"
                      onclick="bimOriginFilter.renamePlan()"
                    >
                      重命名
                    </li>
                    <!-- <li id="originOther_f_faq" onclick="bimOriginFilter.createFlow()">发起流程</li> -->
                  </ul>
                </div>
              </div>
              <div class="footr_box" id="updateSelect" style="display: none">
                <div class="box_btn_op">
                  <div class="clearfix">
                    <el-button
                      class="fr ml_20 mar-top3"
                      type="primary"
                      onclick="bimOriginFilter.attribute_update()"
                      size="small"
                      >更新选择集</el-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 碰撞检查 -->
      <div class="crashCheck_box" id="crashCheckDiv">
        <div class="box_title">碰撞检查</div>
        <div class="btnClose" onclick="CrashCheck.close()">×</div>
        <div class="box_content">
          <div class="tab_title">
            <ul id="crashCheck_tabs" class="clearfix">
              <li class="current" onclick="CrashCheck.select(this)">
                <a href="#" title="选择构件">选择构件</a>
              </li>
              <li onclick="CrashCheck.select(this)">
                <a href="#" title="碰撞结果">碰撞结果</a>
              </li>
            </ul>
          </div>
          <div id="menu_crashCheck_content_box">
            <div id="crashCheck_tab1" class="menu_table dis-bok">
              <div class="box">
                <div class="tree">
                  <ul id="crashCheck_tree1" class="ztree"></ul>
                </div>
                <div
                  class="export"
                  onclick="CrashCheck.export('crashCheck_tree1')"
                >
                  导入模型目前选择构件
                </div>
              </div>
              <div class="box">
                <div class="tree">
                  <ul id="crashCheck_tree2" class="ztree"></ul>
                </div>
                <div
                  class="export"
                  onclick="CrashCheck.export('crashCheck_tree2')"
                >
                  导入模型目前选择构件
                </div>
              </div>
              <div class="todo" onclick="CrashCheck.todo()">进行碰撞</div>
            </div>
            <div id="crashCheck_tab2" class="menu_table dis-none">
              <div class="tree">
                <ul id="crashCheck_resultTree" class="ztree"></ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!--添加标签 -->
      <div class="AddLable">
        <input type="hidden" id="mobl10" />
        <input type="hidden" id="mobl11" />
        <input type="hidden" id="mobl12" />
        <div>
          <label class="labelName">名称：</label>
          <input id="lableName" type="text" />
        </div>
        <br />
        <div>
          <label class="labelName">地点：</label>
          <input id="lableAddr" type="text" />
        </div>
        <br />
        <div>
          <label class="labelName">拍摄时间：</label>
          <input id="lableTime" type="text" placeholder="yyyy-MM-dd" />
        </div>
        <br />
        <div>
          <label>类型：</label>
          <dl class="labelType"></dl>
        </div>
        <br />
        <div class="isQJ dis-none">
          <label class="labelName">是否全景图：</label>
          <input type="radio" name="isQJ" value="1" />是
          <input type="radio" name="isQJ" value="0" checked />否
        </div>
        <br />
        <div class="lableFile">
          <label>文件：</label>
          <button
            type="button"
            class="layui-btn layui-btn layui-btn-sm marginLeft10"
            id="lableFile"
          >
            选择文件
          </button>
        </div>
        <br />
        <div class="qjLink dis-none">
          <label class="labelName">全景链接：</label>
          <input id="qjLink" type="text" />
        </div>
        <br />
        <div class="form-group rt">
          <button id="lableSubmit"></button>
          <button
            type="button"
            class="layui-btn"
            onclick="EaBIM.lableSaveChange()"
          >
            提交
          </button>
          <!-- <button type="button" class="layui-btn" id="lableSubmit">提交</button> -->
        </div>
        <br />
      </div>
      <!-- 添加参数 -->
      <div class="AddProperty">
        <p>
          <button
            type="button"
            class="layui-btn layui-btn-normal layui-btn-sm marginLeft10"
            onclick="EaBIM.addPropertyGroup()"
          >
            添加分组
          </button>
          <br />
          <br />
        </p>
        <!-- <div class="layui-collapse">
          <h2 class="layui-colla-title">
            分组名称：<input type="text">
            <button type="button" class="layui-btn layui-btn-danger layui-btn-sm rightBtn" onclick="EaBIM.removePropertyGroup(this)">-</button>
            <button type="button" class="layui-btn layui-btn layui-btn-sm rightBtn"  onclick="EaBIM.addProperty(this)">+</button>
            </h2>
          <div class="layui-colla-content layui-show">
            <h2 class="layui-colla-title">
             分类名称：<input type="text">
             分类数值：<input type="text">
            <button type="button" class="layui-btn layui-btn-danger layui-btn-sm rightBtn" onclick="EaBIM.removeProperty(this)">-</button></h2>
          </div>
        </div>-->

        <!-- <div class="form-group rt">
        <button type="button" class="layui-btn" onclick="saveChange()">提交</button>
        </div>-->
      </div>
      <div id="hide" class="gray"></div>
    </div>
    <div id="middle1"></div>
    <div :style="style2" id="right1">
      <el-row class="height40p">
        <el-col :span="24">
          <el-select
            @change="change2DModel"
            v-model="value2D"
            placeholder="请选择2D图纸"
            class="width100"
          >
            <el-option
              v-for="item in list2D"
              :key="item.value"
              :label="item.tdmd03"
              :value="item.tdmd04"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <div id="My2DViewerDiv"></div>
    </div>
    <el-dialog title="分享视点" :visible.sync="dialogShareViewpoint">
      <el-card class="box-card">
        <div style="width: 50%; margin: 0px auto">
          <el-date-picker
            type="datetime"
            placeholder="选择分享时间"
            v-model="shareTime"
            style="width: 100%"
          ></el-date-picker>
        </div>
        <div
          class="dialog-footer"
          style="text-align: center; margin-bottom: 10px; margin-top: 30px"
        >
          <el-button @click="dialogShareViewpoint = false">取 消</el-button>
          <el-button type="primary" @click="submitShare()">确 定</el-button>
        </div>
      </el-card>
    </el-dialog>

    <el-dialog
      title="视点分享管理"
      :visible.sync="Viewpointshare.dialogShareManage"
      width="65%"
    >
      <el-table
        :data="Viewpointshare.viewpointData"
        style="margin-bottom: 30px"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column
          property="vipo01"
          label="序号"
          type="index"
        ></el-table-column>
        <el-table-column
          property="vipo02"
          label="视点名称"
          sortable
        ></el-table-column>
        <el-table-column
          property="vipo09"
          label="创建时间"
          sortable
        ></el-table-column>
        <el-table-column
          property="vipo14"
          label="分享时间"
          sortable
        ></el-table-column>
        <el-table-column
          property="vipo15"
          label="到期时间"
          sortable
        ></el-table-column>
        <el-table-column property="vipo16" label="是否启用" sortable>
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.vipo16"
              @change="EnableState(scope.$index, scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              size="mini"
              plain
              @click="shareDetails(scope.row)"
            >
              <i class="el-icon-warning-outline"></i>
            </el-button>
            <el-popconfirm
              title="这个分享确定删除吗？"
              @confirm="Delete(scope.$index, scope.row)"
            >
              <el-button slot="reference" type="danger" size="mini" plain>
                <i class="el-icon-delete"></i>
              </el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :title="Viewpointshare.title"
      :visible.sync="Viewpointshare.dialogShareDetails"
      width="50%"
      @close="shareManageInit()"
    >
      <div style="display:inline-block;float：left;margin-left:50px">
        <div id="qrcode" style="margin: 20px"></div>
        <div style="width: 208px; text-align: center; margin: 20px">
          <a class="down" @click="download('code')">
            <i class="el-icon-download"></i>保存二维码
          </a>
        </div>
      </div>
      <div style="display: inline-block; float: right; margin-right: 50px">
        <div>
          <el-image
            :src="Viewpointshare.imageurl"
            style="width: 208px; height: 208px; margin: 20px"
          >
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
        </div>
        <div style="width: 208px; text-align: center; margin: 0 auto">
          <a class="down" @click="download('img')">
            <i class="el-icon-download"></i>保存图片
          </a>
        </div>
      </div>
      <div style="margin-right: 50px; width: 60%">
        <div style="margin: 20px">
          <label>链接：</label>
          <el-input class=".copylink" placeholder v-model="Viewpointshare.link">
            <template slot="append">
              <el-button id="btn_copy" type="primary" @click="copylink()"
                >复制链接</el-button
              >
            </template>
          </el-input>
        </div>
        <div style="margin: 20px">
          <label>设置到期时间：</label>
          <el-date-picker
            type="datetime"
            placeholder="选择到期时间"
            v-model="Viewpointshare.effectiveTime"
            style="width: 100%"
            @change="changeEffectiveTime()"
          ></el-date-picker>
        </div>
      </div>
    </el-dialog>
    <!-- 高级筛选 -->
    <el-dialog
      title="筛选条件"
      :visible.sync="hightFilterShow"
      width="50%"
      center=""
    >
      <el-form
        ref="form"
        v-loading="searchloading"
        element-loading-text="初始化模型数据中..."
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
        :model="filterModel"
        label-width="10%"
      >
        <el-form-item
          label="筛选条件"
          style="max-height: 300px; min-height: 150px; overflow: auto"
        >
          <div
            v-for="(item, index) in filterModel.condition"
            :key="index"
            :style="{ marginTop: index > 0 ? '5px' : '0px' }"
          >
            <el-select
              v-if="index > 0"
              v-model="item.search4"
              style="width: 100px"
            >
              <el-option label="并且" value="并且"></el-option>
              <el-option label="或者" value="或者"></el-option>
            </el-select>

            <el-select
              v-model="item.search1"
              style="width: 250px; margin-left: 2px"
              filterable=""
            >
              <el-option
                v-for="(item1, index1) in item.searchCon"
                :label="item1.name"
                :value="item1.name"
                :key="index1"
              ></el-option>
            </el-select>
            <el-select
              v-model="item.search2"
              style="width: 100px; margin-left: 2px"
            >
              <el-option label="大于" value=">"></el-option>
              <el-option label="小于" value="<"></el-option>
              <el-option label="等于" value="="></el-option>
              <el-option label="包含" value="include"></el-option>
            </el-select>
            <!-- <el-input
              style="width: 150px; margin-left: 2px"
              v-model="item.search3"
              placeholder="请输入条件"
            >
            </el-input> -->
            <el-select
              v-model="item.search3"
              style="width: 150px; margin-left: 2px"
              filterable
              allow-create
            >
              <el-option
                v-for="(item1, index1) in item.searchCon.find(
                  (x) => x.name == item.search1
                )
                  ? item.searchCon.find((x) => x.name == item.search1).list
                  : []"
                :label="item1"
                :value="item1"
                :key="index1"
              ></el-option>
            </el-select>
            <el-button
              type="success"
              style="margin-left: 5px"
              size="mini"
              icon="el-icon-plus"
              circle
              v-if="index == 0"
              @click="dealCon(index, 'add')"
            ></el-button>
            <el-button
              type="danger"
              size="mini"
              style="margin-left: 5px"
              icon="el-icon-delete"
              circle
              v-else
              @click="dealCon(index, 'del')"
            ></el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="SubmitSerch">立即查询</el-button>
          <el-tooltip effect="dark" placement="top">
            <div slot="content">
              筛选范围：<br />当前选择构件，<br />无选择则以全模型
            </div>
            <el-button type="warning" @click="refreshModelData"
              >刷新数据</el-button
            >
          </el-tooltip>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  GetWorkPlaneTree2,
  FindWorkPlaneModel,
  GetViewPointShare,
  UpdateViewPointShareState,
  DelViewPointShare,
} from "@/setAxios";
import interact from "interactjs";
import { download } from "@/tools/tool";
// import $ from "jquery";
export default {
  name: "viewModel",
  components: {},
  data() {
    return {
      //高级搜索开始---------------------------
      filterModel: {
        condition: [
          {
            search1: null,
            searchCon: [],
            search2: null,
            search3: null,
            search4: "并且",
          },
        ],
      },
      searchloading: false,
      hightFilterShow: false,
      searchCon: {
        search1: null,
        searchCon: [],
        search2: null,
        search3: null,
        search4: "并且",
      },
      modelData: [],
      //高级搜索结束-----------------------------
      count: 0,
      style2:
        "width: 500px; height: 400px; position: absolute; right: 20px; top: 14%; z-index: 1;display:none",
      value2D: "",
      testSshow: true,
      url: "",
      pid: -1,
      options: [],
      isdblclick: true,
      btnColor: "",
      show: true,
      timer: null,
      modelSelectIds: [],
      // optionsAdd: {},
      bool: true,
      list2D: null,
      changeSplit: false,
      modelId: "",
      dialogShareViewpoint: false,
      viewpointIds: "",
      shareTime: "",
      Viewpointshare: {
        dialogShareManage: false,
        viewpointData: [],
        dialogShareDetails: false,
        imageurl: "",
        sharedata: "",
        link: "",
        effectiveTime: "",
        title: "",
      },
    };
  },
  methods: {
    //高级筛选开始---------------------------------------------
    refreshModelData() {
      this.searchloading = true;
      EaBIM.DealModelData();
    },
    dealCon(index, type) {
      if (type == "add") {
        this.filterModel.condition.push(
          JSON.parse(JSON.stringify(this.searchCon))
        );
      } else {
        delete this.filterModel.condition.splice(index, 1);
      }
    },
    SubmitSerch() {
      var a = this.filterModel.condition.filter(
        (y) => y.search1 == null || y.search2 == null || y.search3 == null
      );
      if (a.length) {
        this.$message.error("请填写完整筛选条件");
        return;
      }
      var showData = this.modelData.filter((ele) => {
        let bol = true;
        this.filterModel.condition.forEach((ele2) => {
          if (ele2.search4 == "并且") {
            if (ele2.search2 == ">") {
              bol = bol && ele[ele2.search1] > ele2.search3;
            } else if (ele2.search2 == "<") {
              bol = bol && ele[ele2.search1] < ele2.search3;
            } else if (ele2.search2 == "include") {
              bol = bol && ele[ele2.search1].includes(ele2.search3);
            } else {
              bol = bol && ele[ele2.search1] == ele2.search3;
            }
          } else {
            if (ele2.search2 == ">") {
              bol = bol || ele[ele2.search1] > ele2.search3;
            } else if (ele2.search2 == "<") {
              bol = bol || ele[ele2.search1] < ele2.search3;
            } else if (ele2.search2 == "include") {
              bol = bol || ele[ele2.search1].includes(ele2.search3);
            } else {
              bol = bol || ele[ele2.search1] == ele2.search3;
            }
          }
        });
        return bol;
      });
      var dbIds = [];
      showData.forEach((v) => {
        dbIds.push(v["dbId"]);
      });
      if (dbIds.length)
        this.$message.success(`一共查找出 ${dbIds.length} 个构件`);
      else this.$message.warning(`暂无符合条件的构件`);
      EaBIM.view.select(dbIds);
    },
    DealModelData(data) {
      this.$message.success(`初始化${data.length}个构件`);
      this.modelData = data;
      this.searchloading = false;
      var data1 = [];
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        Object.keys(element).forEach((key) => {
          var item = data1.find((x) => x.name == key);
          if (item) {
            if (!item.list.includes(element[key]))
              data1.find((x) => x.name == key).list.push(element[key]);
          } else {
            data1.push({
              name: key,
              list: [element[key]],
            });
          }
        });
      }
      data1 = data1.filter(
        (x) => x.list.length > 0 && x.list[0] + "".trim() != ""
      );
      data1.forEach((v) => {
        v.list = v.list.splice(0, 100);
      });
      this.searchCon = {
        search1: null,
        searchCon: data1,
        search2: null,
        search3: null,
        search4: "并且",
      };
      this.filterModel.condition = [
        {
          search1: null,
          searchCon: data1,
          search2: null,
          search3: null,
          search4: "并且",
        },
      ];
    },
    //高级筛选
    hightFilter() {
      this.hightFilterShow = true;
      if (!this.modelData.length) {
        this.searchloading = true;
        EaBIM.DealModelData();
      }
    },
    //高级筛选结束---------------------------------------------

    updateViewTime(ids) {
      this.dialogShareViewpoint = true;
      this.viewpointIds = ids;
    },
    submitShare() {
      let params = {
        ids: this.viewpointIds,
        time: this.shareTime,
        type: 1,
      };
      if (params.time == "") {
        this.$message.warning("请选择分享时间！");
        return;
      }
      UpdateViewPointShareState(params).then((res) => {
        this.$message.success("分享成功！");
        this.dialogShareViewpoint = false;
        this.shareTime = "";
      });
    },
    shareManageInit() {
      this.Viewpointshare.dialogShareManage = true;
      let params = {
        uid: localStorage.getItem("id"),
        modelId: this.modelId,
      };
      GetViewPointShare({ params }).then((res) => {
        res.Data.forEach((item, index) => {
          item.vipo16 = item.vipo16 == 1 ? true : false;
        });
        this.Viewpointshare.viewpointData = res.Data;
      });
    },
    EnableState(index, row) {
      let params = {
        ids: row.vipo01,
        type: row.vipo16 ? 1 : 0,
      };
      UpdateViewPointShareState(params).then((res) => {
        if (res.Code == 1) {
          this.$message.success("操作成功！");
        }
      });
    },
    Delete(index, row) {
      let params = {
        id: row.vipo01,
      };
      DelViewPointShare(params).then((res) => {
        if (res.Code == 1) {
          this.$message.success("删除成功！");
          this.shareManageInit();
        }
      });
    },
    shareDetails(data) {
      this.Viewpointshare.dialogShareDetails = true;
      var code = `modelId=${EaBIM.modelData.modelId}^@^id=${data.vipo01}^@^type=fxsd`;
      code = Base64.encode(code);
      var url = `${window.location.origin}/#/viewModel?Code=${code}`;

      this.$nextTick(() => {
        $("#qrcode").empty();
        var a = new QRCode("qrcode", {
          text: url,
          width: 208,
          height: 208,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H,
        });
      });
      this.Viewpointshare.imageurl = this.$store.state.baseUrl + data.vipo05;
      this.Viewpointshare.sharedata = data;
      this.Viewpointshare.effectiveTime = data.vipo15;
      this.Viewpointshare.link = url;
      this.Viewpointshare.title = "BIM协同（" + data.vipo02 + "）";
    },
    download(type) {
      var data = this.Viewpointshare.sharedata;
      if (type == "img") {
        download(this.$store.state.baseUrl + data.vipo05, data.vipo02);
      } else {
        download(document.querySelector("#qrcode img").src, data.vipo02);
      }
    },
    copylink() {
      let that = this;

      var clipboard = new ClipboardJS("#btn_copy", {
        text: function () {
          var url = that.Viewpointshare.link;
          return url;
        },
      });
      clipboard.on("success", function (e) {
        console.log(that.$message.closeAll());
        that.$message.success("链接复制成功！");
      });
    },
    changeEffectiveTime() {
      var data = this.Viewpointshare.sharedata;
      let params = {
        ids: data.vipo01,
        time: this.Viewpointshare.effectiveTime,
        type: 1,
      };
      if (params.time == "") {
        this.$message.warning("请选择到期时间！");
        return;
      }
      UpdateViewPointShareState(params).then((res) => {
        if (true) {
          this.$message.success("操作成功！");
        }
      });
    },
    // 判断类型
    judge(item) {
      if (item.wopl07 == 1) {
        return (item.iconSkin = "pIcon01");
      } else if (item.wopl07 == 2) {
        return (item.iconSkin = "pIcon02");
      } else if (item.wopl07 == 3) {
        return (item.iconSkin = "pIcon03");
      } else {
        return (item.iconSkin = "pIcon04");
      }
    },
    //初始化ztree
    init() {
      var _this = this;
      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: false,
        },
        data: {
          key: {
            name: "label",
          },
          simpleData: {
            enable: true,
            idKey: "ID",
            pIdKey: "ParentId",
          },
        },
        edit: {
          enable: true,
          showRemoveBtn: false,
          showRenameBtn: false,
          drag: {
            isMove: true,
            inner: true,
            prev: false,
            next: true,
          },
        },
        callback: {
          onClick: onclick,
        },
      };
      var objs = $.fn.zTree.init($("#WorkPlaneTree"), setting, this.options);
      if (objs != null) {
        if (localStorage.treeNid) {
          var currentNode = objs.getNodeByParam("ID", localStorage.treeNid);
          var name = currentNode.tId + "_a";
          $("#" + name).click();
        } else {
          $("#WorkPlaneTree_1_a").click();
        }
      }
      function onclick(event, treeId, treeNode) {
        localStorage.setItem("treeNid", treeNode.ID);
        _this.showModel(treeNode.ID);
      }
    },
    change2DModel(val) {
      EaBIM.load2DModel(val);
    },
    initSpit() {
      function $d(id) {
        return document.getElementById(id);
      }
      var left = $d("left1"),
        hide = $d("hide"),
        view = $d("MyViewerDiv"),
        right = $d("right1"),
        middle = $d("middle1");
      var middleWidth = 2;
      middle.onmousedown = function (e) {
        hide.style.display = "block";
        var disX = (e || event).clientX;
        middle.left = middle.offsetLeft;
        document.onmousemove = function (e) {
          var iT = middle.left + ((e || event).clientX - disX);
          var e = e || window.event,
            tarnameb = e.target || e.srcElement;
          var maxT = document.body.clientWidth;
          iT < 150 && (iT = 150);
          iT > maxT - 150 && (iT = maxT - 150);
          middle.style.left = left.style.width = iT + "px";
          view.style.width = left.style.width = iT + "px";
          hide.style.width = left.style.width = iT + "px";
          right.style.width =
            document.body.clientWidth - iT - middleWidth + "px";
          EaBIM.view.resize();
          EaBIM.view2D.resize();
          return false;
        };
        document.onmouseup = function () {
          hide.style.display = "none";
          document.onmousemove = null;
          document.onmouseup = null;
          middle.releaseCapture && middle.releaseCapture();
        };
        middle.setCapture && middle.setCapture();
        return false;
      };
    },
    changeSplitF() {
      if (this.changeSplit) {
        this.style2 =
          "width: 500px; height: 400px; position: absolute; right: 20px; top: 14%; z-index: 1;";
        $("#MyViewerDiv").css("width", "100%");
        $("#left1").css("width", "100%");
        $("#middle1").hide();
      } else {
        this.style2 =
          "width:50%; height: 100vh;float:right; position: absolute; right: 0px; top: 0px; z-index:1; left: inherit;";
        this.initSpit();
        $("#MyViewerDiv").css("width", "50%");
        $("#left1").css("width", "50%");
        $("#hide").css("width", "50%");
        $("#right1").css("width", "50%");
        $("#middle1").show();
        $("#middle1").css("left", "50%");
      }
      setTimeout(() => {
        EaBIM.view.resize();
        EaBIM.view2D.resize();
      }, 10);
      this.changeSplit = !this.changeSplit;
    },
    testShowBtn() {
      if ($(".Yuan-title").css("display") != "none") {
        $(".Yuan-title").css("display", "none");
      } else {
        $(".Yuan-title").css("display", "block");
      }
    },
    viewers(data) {
      data.enterType = "yydh";
      EaBIM.localServerModels(data);
    },
    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
        pid: this.pid,
      };
      GetWorkPlaneTree2(params).then((res) => {
        this.options = res.Data;
        this.options.forEach((item) => {
          this.judge(item);
        });
        this.init();
      });
    },
    showModel(value, index) {
      if (value.length) {
        value = value[0];
      }
      let params = {
        id: value,
      };
      FindWorkPlaneModel(params).then((res) => {
        if (res.Data == null) {
          this.$message({
            type: "warning",
            message: this.$t('工单任务.此节点未绑定模型或选择集'),
          });
          return false;
        }
        let data = res.Data;
        this.modelId = res.Data.modelId;
        this.viewers(data);
      });
    },
  },
  created() {
    this.getData();
    window.list2dVM = this;
    this.$store.state.isClickProject = true;
    window.DealModelData = this.DealModelData;
  },
  mounted() {
    document.oncontextmenu = function () {
      return false;
    };
    window.updateViewTime = this.updateViewTime;
    Fcis.Fc(".Yuan", "#drag");
    Fcis.Fc(".lll", "#div_viewpoint");
    Fcis.Fc(".lll", "#gg");
    Fcis.Fc(".lll", "#crashCheckDiv");

    interact(".Yuan-title").resizable({
      edges: { top: false, left: false, bottom: true, right: true },
      listeners: {
        move: function (event) {
          let { x, y } = event.target.dataset;

          x = (parseFloat(x) || 0) + event.deltaRect.left;
          y = (parseFloat(y) || 0) + event.deltaRect.top;

          Object.assign(event.target.style, {
            width: `${event.rect.width}px`,
            height: `${event.rect.height}px`,
            transform: `translate(${x}px, ${y}px)`,
          });

          Object.assign(event.target.dataset, { x, y });
        },
      },
    });
  },
};
</script>
<style lang="less" scoped>
// @import url("../../../public/Content/css/style.css");
/deep/ .view {
  padding: 0;
}
#MyViewerDiv {
  height: 100%;
  width: 100%;
  position: absolute;
  // float: left;
}
#My2DViewerDiv {
  height: 95%;
  width: 100%;
  position: absolute;
  // float: left;
}
.home {
  // overflow: auto;
  height: 98%;
  position: relative;
}
.body_viewpoint {
  overflow: hidden;
  height: 90%;
  overflow-y: auto;
}
.body_viewpoint .treeDemo_viewpoint {
  // background: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 80%;
  border: none;
  // overflow-y: auto;
  // overflow-x: hidden;
  margin-bottom: 15px;
}
.layer-background {
  background: rgba(255, 255, 255, 0.8) !important;
}
.liveBarCodeShow {
  z-index: 10;
  position: absolute;
  width: 410px;
  // background: #eee;
}
.search-input {
  width: 140px;
}
.back {
  background: #eee;
}
#middle1 {
  width: 0;
  height: 100%;
  position: absolute;
  top: 0;
  left: 50%;
  z-index: 10;
  border-left: 18px dashed transparent;
  margin-left: -9px;
  cursor: e-resize;
  display: none;
}
/deep/ .ztree li span.button.pIcon01_ico_open,
/deep/ .ztree li span.button.button.pIcon01_ico_close,
/deep/ .ztree li span.button.pIcon01_ico_docu {
  margin-right: 2px;
  background: url("../../assets/img/singleMode.png") no-repeat scroll 3px 1px
    transparent;
  vertical-align: top;
  background-size: 80%;
  vertical-align: middle;
}

/* 新增 */
#left1 {
  height: 100vh;
  width: 100%;
  overflow: hidden;
  z-index: 1;
}
.YuanTitleDrag {
  height: 20px;
  width: 100%;
  cursor: all-scroll;
}
.sdbcName {
  font-size: 20px;
  font-weight: 300;
  cursor: all-scroll;
}
.btnSearch {
  position: absolute;
  left: 0;
}
.pos-re-left4 {
  position: relative;
  left: 4px;
}
.clo1 {
  font-weight: 300;
  position: absolute;
  right: 0 !important;
  color: #c3c3c3;
  font-size: 16px;
}
.w-h-bg-cor {
  width: 265px;
  height: 40px;
  /* background-color: #fff; */
}
#vp-btn-mark {
  margin: 1px 0 0 26px;
  display: inline-block;
}
#vp-btn-save {
  display: inline-block;
}
.dis-none {
  display: none;
}
.rMenu {
  visibility: hidden;
}
.pos-fixed {
  position: fixed;
}
.filter_box {
  cursor: default;
  display: none;
}
.dis-bok {
  display: block;
}
.mar-top3 {
  margin-top: 3%;
}
.crashCheck_box {
  cursor: default;
}
.gray {
  opacity: 0;
}
.height40p {
  height: 40px;
}
.width100 {
  width: 100%;
}
#vp-searchtxt {
  padding-left: 20px;
}
.down {
  cursor: pointer;
  color: #409eff;
}
</style>